import type { Dispatcher } from '@/events/dispatcher';
import { createPreviewModalOpenEvent } from '@/events/modalEvents';

export default {
  install: (app: any, dispatcher: Dispatcher) => {
    app.provide('previewModal', (orderId: number) => {
      dispatcher?.dispatch(createPreviewModalOpenEvent(orderId));
    });
  },
};
